// extracted by mini-css-extract-plugin
export var section_header = "categorylayout-module--section_header--q-V9E";